import { useTranslation } from 'react-i18next';

import {
    Anchor,
    Body1,
    Modal,
    Stack,
} from '@myphx-engineering/phx-design-system';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

export const PricingDisclosure = () => {
    const [opened, { toggle }] = useDisclosure(false);
    const { t } = useTranslation();

    return (
        <>
            <Anchor onClick={toggle} textAlign="left">
                {t('pricing.disclosure.link')}
            </Anchor>

            <Modal
                opened={opened}
                title={t('pricing.disclosure.modal.title')}
                onClose={toggle}
            >
                <Stack gap="sm">
                    <Body1>{t('pricing.disclosure.modal.body1')}</Body1>
                    <Body1>{t('pricing.disclosure.modal.body2')}</Body1>
                </Stack>
            </Modal>
        </>
    );
};
